import { useQuery } from 'react-query';
import axios from 'axios';

const passwordUrl = 'xm/free/api/password';

export function useGetPasswordPolicy() {
  return useQuery(
    'passwordPolicy',
    () => axios.get(`${passwordUrl}/policy`).then(({ data }) => data),
    {
      refetchOnMount: 'always',
    },
  );
}

export function useValidatePassword(password, config = {}) {
  return useQuery(
    'validatePassword',
    () =>
      axios
        .post(`${passwordUrl}/validate`, { password })
        .then(({ data }) => data),
    config,
  );
}
